import { Expose, Type } from 'class-transformer';
import { Positionable } from '../../map/model/positionable';
import { Nameable } from '../../common/model/nameable';
import * as L from 'leaflet';
import { ValueField } from '../../settings/model/value-field';
import { FieldType } from '../../settings/model/field-type';
import { ZoneType } from './zone-type';
import { Vehicle } from './vehicle';

export class Zone implements Positionable, Nameable {
  @Expose({ name: 'zone_id' })
  id: number;
  @Expose({ name: 'latitude' })
  latitude: number;
  @Expose({ name: 'longitude' })
  longitude: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'radius' })
  radius: number;
  @Expose({ name: 'color' })
  color: string;
  @Expose({ name: 'type' })
  type: ZoneType;
  @Expose({ name: 'vehicles' })
  @Type(() => Vehicle)
  vehicles: Vehicle[];

  static getName(): string {
    return 'ZONE';
  }

  getClassName(): string {
    return 'Zone';
  }

  getPosition(): L.LatLng {
    return L.latLng(this.latitude, this.longitude);
  }
}

export const zoneFields: ValueField[] = [
  Object.assign(new ValueField(), {
    name: 'id',
    type: FieldType.INTEGER,
    primaryKey: true,
    visible: false
  }),
  Object.assign(new ValueField(), {
    name: 'name',
    type: FieldType.TEXT,
    visible: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: 'description',
    type: FieldType.TEXT,
    visible: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: 'latitude',
    type: FieldType.FLOAT,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'longitude',
    type: FieldType.FLOAT,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: 'radius',
    type: FieldType.INTEGER,
    visible: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: 'type',
    type: FieldType.INTEGER,
    visible: true,
    canFilter: true,
    options: [
      { key: 0, value: 'generalZone' },
      { key: 1, value: 'depot' },
      { key: 2, value: 'petrolStation' }
    ]
  })
];
